import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { ConfigurationService } from "src/app/configurations/configurationService";
import { Status, Answer, Severity } from "../../constants/constants";
import { OrdersService } from "../orders.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AppMainComponent } from "src/app/app.main.component";
import { TitleCasePipe } from "@angular/common";

@Component({
    selector: "app-order-fields",
    templateUrl: "./order-fields.component.html",
    styleUrls: ["./order-fields.component.scss"],
})
export class OrderFieldsComponent implements OnChanges, OnInit {
    @Input() allOrderFullfillmentStatus;
    @Input() ordersFullfillmentConfig;
    @Input() allOrderBackOrderStatus;
    @Input() ordersBackOrderConfig;

    fillableData = [];
    backOrders = [];
    stageChange = [
        { id: 1, name: "Enable Comment Popup", isDefault: true }
    ];
    displayEditFullfillable = false;
    color;
    name;
    selectedFullfillableInfo;
    fullfillHeader;

    //return
    activeIndex: number=0;
    allReasons = [];
    allTypes = [];
    searchBy = [];
    dataTypes = [];
    rmaLocations=[];
    defaultLocation: any;
    reasonForm: FormGroup;
    answertypeConstants = Answer;
    statusConstants = Status;
    addEditHeader;
    displayAddEditData = false;
    invalidData: boolean = true;
    isEditFieldData: boolean = true;
    isDisabledFieldData = false;
    formSubmitted = false;
    ErrorMessageName = "";
    typeId = 0;

    constructor(
        private confirmationService: ConfirmationService, private service: ConfigurationService,
        private messageService: MessageService, private orderConfigService: OrdersService,
        private fb: FormBuilder, private app: AppMainComponent, private titlecasePipe: TitleCasePipe
        ) { }


    ngOnInit(): void {
        this.orderConfigService.getFullfill().subscribe(e => {
            if (e) {
                this.showAddFullfill();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.allOrderFullfillmentStatus &&
            changes.allOrderFullfillmentStatus.currentValue
        ) {
            this.fillableData = changes.allOrderFullfillmentStatus.currentValue;
        }
        if (
            changes.ordersFullfillmentConfig &&
            changes.ordersFullfillmentConfig.currentValue
        ) {
            this.ordersFullfillmentConfig =
                changes.ordersFullfillmentConfig.currentValue;
        }
        if (
            changes.allOrderBackOrderStatus &&
            changes.allOrderBackOrderStatus.currentValue
        ) {
            this.allOrderBackOrderStatus =
                changes.allOrderBackOrderStatus.currentValue;
        }
        if (
            changes.ordersBackOrderConfig &&
            changes.ordersBackOrderConfig.currentValue
        ) {
            this.ordersBackOrderConfig =
                changes.ordersBackOrderConfig.currentValue;
        }
    }

    showAddFullfill() {
        this.fullfillHeader = 'Add Fullfill Data';
        this.name = '';
        this.color = '';
        this.displayEditFullfillable = true;
    }
    showEditFillableData(c) {
        this.fullfillHeader = 'Edit Fullfill Data';
        this.selectedFullfillableInfo = c;
        this.name = c.name;
        this.color = c.color;
        this.displayEditFullfillable = true;
    }

    save() {
        this.allOrderFullfillmentStatus.forEach((element) => {
            if (element.id == this.selectedFullfillableInfo.id) {
                element.name = this.name;
                element.color = this.color;
            }
        });
        this.ordersFullfillmentConfig.configJSONValue = JSON.stringify(
            this.allOrderFullfillmentStatus
        );

        this.service
            .updateConfiguration(this.ordersFullfillmentConfig)
            .then(() => {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Fullfillable status updated successfully...",
                });
                this.displayEditFullfillable = false;
            })
            .catch(() => {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }

    confirm(data) {
        this.confirmationService.confirm({
            message: "Are you sure that you want to proceed?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            rejectLabel: "Cancel",
            accept: () => {
                data.isDefault = !data.isDefault;

                if (data.name == "Enabling back order") {
                    this.allOrderBackOrderStatus.forEach((element) => {
                        if (element.id == data.id) {
                            element.isDefault = data.isDefault;
                            element.EnableBackOrderForKit = false;
                            element.EnableBackOrderForBundle = false;
                        } else {
                            element.isDefault = !data.isDefault;
                            element.EnableBackOrderForKit = false
                            element.EnableBackOrderForBundle = false;
                        }
                    });

                    this.ordersBackOrderConfig.configJSONValue = JSON.stringify(
                        this.allOrderBackOrderStatus
                    );
                    this.updateBackOrderConfig();
                }
            },
        });
    }

    //Customer return
    prepareReasonForm() {
        this.reasonForm = this.fb.group({
            name: [null, [Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
            parentTypeId: [0],
            description: [null],
            groupId: [null, [Validators.required]],
            group: [null],
            organizationId: [this.app.companyId],
            colorCodeId: [0],
            statusId: [1],
            status: [null],
            isDefault: [false],
            oldRecordId: [0],
            id: [0],
            createdSource: [this.app.userIP],
            updatedSource: [this.app.userIP],
            createdBy: [this.app.userId],
            updatedBy: [this.app.userId],
            createdDate: [new Date().toISOString()],
            updatedDate: [new Date().toISOString()]
        })
    }

    showAddReturnReason() {
        this.displayAddEditData = true;
        this.addEditHeader = "Add Return Reason";
        this.invalidData = false;
        this.isEditFieldData = false;
        this.getRMAGroup(0);
        this.prepareReasonForm();
    }

    showEditData(value) {
        this.prepareReasonForm();
        this.addEditHeader = "Edit Return Reason";
        this.displayAddEditData = true;
        this.isEditFieldData = true;
        this.isDisabledFieldData = false;
        this.invalidData = false;
        this.getRMAGroup(0);
        this.reasonForm.patchValue(value);
        this.reasonForm.controls['statusId'].setValue(value.statusId==1?true:false);
    }

    closeAddEditData(): void {
        this.displayAddEditData = false;
        this.isDisabledFieldData = false;
        this.invalidData = false;
        this.prepareReasonForm();
    }

    eventCalled(product) {
        if (product.isDefault) {
            this.orderConfigService.setReasonTypeDefault(product.id).subscribe(response => {
                for(let type of this.allTypes){
                    if(type.id!=product.id){
                        type.isDefault = false;
                    }
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
            })
        }
    }

    saveReason(value){
        if(!this.isEditFieldData){
            const lowerCaseNames = [];
            for (let s of this.allReasons) {
                lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ""));
            }
            if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, "")) > -1) {
                this.invalidData = true;
            } else {
                this.invalidData = false;
                this.addReason(value);
            }
        }else{
            const duplicateRecord = this.allReasons?.find(
                (depOb) =>
                    depOb.name.toLowerCase() == value.name.toLowerCase() &&
                    depOb.id !== value.id
            );
            if (duplicateRecord) {
                this.invalidData = true;
            } else {
                this.invalidData = false;
                this.updateReason(value);
            }
        }
    }

    addReason(value){
        value.groupId = value.groupId?.id;
        this.orderConfigService.addReturnReason(value).then(() => {
            this.messageService.add({
                severity: Severity.Success,
                summary: this.titlecasePipe.transform(
                    Severity.Success
                ),
                detail: "Reason Added successfully...",
            });
            this.getReturnData(0, this.dataTypes[0].id);
            this.displayAddEditData = false;
        })
        .catch(() => {
            this.displayAddEditData = false;
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(
                    Severity.Error
                ),
                detail: "Error occurred while saving data...",
            });
        });
    }

    updateReason(value){
        value.statusId = (value.StatusId?1:2);
        this.orderConfigService.updateReturnReason(value).then(() => {
            this.messageService.add({
                severity: Severity.Success,
                summary: this.titlecasePipe.transform(
                    Severity.Success
                ),
                detail: "Reason Updated successfully...",
            });
            this.getReturnData(0, this.dataTypes[0].id);
            this.displayAddEditData = false;
        })
        .catch(() => {
            this.displayAddEditData = false;
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(
                    Severity.Error
                ),
                detail: "Error occurred while saving data...",
            });
        });
    }

    checkDelete(reason,action){
      this.orderConfigService.checkDeleteStatus(reason.id).subscribe(status=>{
        if(!status){
            if(action=='delete'){
              this.deleteReason(reason);
            }
        }else{
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(
                    Severity.Error
                ),
                detail: "Return reason is already in use.",
            });
            if(action=='status'){
                this.reasonForm.controls['statusId'].setValue(true);
            }
        }
      })
    }

    deleteReason(reason) {
        this.confirmationService.confirm({
            message: "Do you want to delete this reason?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.orderConfigService.deleteReturnReason(reason.id).then(() => {
                        this.messageService.add({
                            severity: Severity.Success,
                            summary: this.titlecasePipe.transform(
                                Severity.Success
                            ),
                            detail: "Deleted Successfully...",
                        });
                        const index = this.allReasons.indexOf(reason);
                        this.allReasons.splice(index, 1);
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(
                                Severity.Error
                            ),
                            detail: "Error occurred while deleting data...",
                        });
                    });
            },
            reject: () => {},
        });
    }

    enableBackOrderforKitBundle(data) {
        if (data.name == "Enabling back order") {
            this.allOrderBackOrderStatus.forEach((element) => {
                if (element.id == data.id) {
                    element.isDefault = data.isDefault;
                    element.EnableBackOrderForKit = data.EnableBackOrderForKit;
                    element.EnableBackOrderForBundle = data.EnableBackOrderForBundle;
                } else {
                    element.isDefault = !data.isDefault;
                }
            });

            this.ordersBackOrderConfig.configJSONValue = JSON.stringify(
                this.allOrderBackOrderStatus
            );
            this.updateBackOrderConfig();
        }
    }

    updateBackOrderConfig() {
        this.service
            .updateConfiguration(this.ordersBackOrderConfig)
            .then(() => {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Back order updated successfully...",
                });
                this.displayEditFullfillable = false;
            })
            .catch(() => {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred while saving data...",
                });
            });
    }

    getRMAGroup(index) {
        this.orderConfigService.getAllGroups().subscribe(group => {
            switch (index) {
                case 0:
                    this.dataTypes = group.filter(g => g.name == 'Return Reason');
                    this.getReturnData(index, this.dataTypes[0].id);
                    break;
                case 1:
                    const reasonType = group.find(g => g.name == 'Return Type');
                    this.getReturnData(index, reasonType.id);
                    break;
                default:
                    const searchBy = group.find(g => g.name == 'Search By');
                    this.getReturnData(index, searchBy.id);
                    break;
            }
        })
    }

    //Customer Returns
    callEvent(event){
       if(event.index==2){
        this.loadRMALocation();
       }else{
        this.getRMAGroup(event.index);
       }
    }

    getReturnData(index, groupId) { 
        this.orderConfigService.getAllReturnData(groupId).subscribe(res => {
            switch (index) {
                case 0:
                    this.allReasons = res;
                    break;
                case 1:
                    this.allTypes = res;
                    break;
                default:
                    this.searchBy = res;
                    break;
            }
        })
    }

    loadRMALocation() {
        this.rmaLocations = [];
        this.orderConfigService.getRMALocations().subscribe({
            next: res => {
                if (res && res.length > 0) {
                    this.rmaLocations = res?.map(l => ({
                        ...l,
                        name: l.locationId + " - " + l.name,
                    }));
                  this.defaultLocation = this.rmaLocations.find(loc=> loc.isRMAWarehouse);
                }
            },
            error: () => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred...' });
            }
        });
    }

    setDefaultRMALocation(){
     this.orderConfigService.setRMALocDefault(this.defaultLocation?.id).subscribe(response=>{
       this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully...' });
     })
  }

}
